import { Component, OnInit, Input } from '@angular/core';
import { ToastrService } from 'ngx-toastr';
import { MatSelectChange } from '@angular/material/select';
import { Urls } from '../../../../utils/catalogue/urls';
import { ApiService } from '../../../../shared/catalogue/services/api.service';
import { CommonDataService } from '../../../../shared/catalogue/services/common-data.service';
import { DATA_PER_PAGE, CANCEL, Something_went_wrong, Sub_setion_deleted } from './../../../../app.constant';
import { CatalogService } from '@catalog/catalog.service';

@Component({
  selector: 'app-add-sub-section',
  templateUrl: './add-sub-section.component.html',
  styleUrls: ['./add-sub-section.component.scss'],
  providers: [CatalogService],
})
export class AddSubSectionComponent implements OnInit {
  userData: any = {};
  @Input() typeList = [];
  @Input() selectedTab : string;

  sectionList = [];
  subSectionList = [];
  pageSize: number = DATA_PER_PAGE;

  constructor(
    private catalogService: CatalogService,
    public apiService: ApiService,
    private toastr: ToastrService,
    public commonDataService: CommonDataService
  ) {}

  ngOnInit() {
    //this.getTypes();
    this.getSubSections();
  }

  public onTypeChange(change: MatSelectChange) {
    this.sectionList = [];
    if (change.value) {
      this.readSections();
    }
  }

  public readSections() {
    const data = {
      typeId: this.userData.typeId,
    };

    this.catalogService.readPDFSections(data).subscribe(
      (response) => {
        this.sectionList = response.data.subTypes;
      },
      (error) => {}
    );
  }

  getTypes = () => {
    this.apiService.getData(Urls.getTypes).subscribe((response: any) => {
      const typeList = response.data.types || [];
      this.typeList = typeList.filter((i) => i.id === 3 || i.id === 4);
    });
    // this.getSubSections();
    // this.getSections();
  };

  getSectionsById = () => {
    const id = this.userData.typeId;
    this.apiService
      .postData(Urls.getSectionsByType, { typeId: id })
      .subscribe((response: any) => {
        this.sectionList = response.data.subTypes;
      });
  };

  getSubSections = () => {
    let obj;
    this.apiService.getData(Urls.getSubSections).subscribe((response: any) => {
      obj = response.data.list;
      if(this.selectedTab === 'Investors'){
        this.subSectionList = obj.filter((obj) => {
          return obj.type === 'Forms' || obj.type === 'Process' || obj.type === 'SEBI Circulars-Scores Portal';
        });
      }else if(this.selectedTab === 'Partners'){
        this.subSectionList = obj.filter((obj) => {
          return obj.type === 'Forms and Marketing Colletarals ' || obj.type === 'Disclosure';
        });
      }else if(this.selectedTab === 'Downloads'){
        this.subSectionList = obj.filter((obj) => {
          return obj.type === 'Downloads';
        });
      }
    });
  };

  editData = (id) => {
    const index = this.subSectionList.findIndex((x) => x.id === id);
    const editData = this.subSectionList[index];
    this.userData.id = editData.id;
    this.userData.typeId = editData.typeId;
    this.userData.sectionId = editData.sectionId;
    this.userData.subSection = editData.subSections;
    this.getSectionsById();
    this.scrollTop();
  };

  scrollTop = () => {
    window.scroll({
      top: 0,
      left: 0,
      behavior: 'smooth',
    });
  };

  deleteData = (id) => {
    this.commonDataService
      .confirm('Are you sure want to delete?', 'md')
      .then((confirmed) => {
        if (confirmed) {
          this.apiService
            .postData(Urls.deleteSubSection, { id })
            .subscribe((response: any) => {
              this.toastr.success(Sub_setion_deleted);
              this.getSubSections();
            });
        }
      })
      .catch(() => {
        this.toastr.error(CANCEL);
      });
  };

  proceesData = (formVal) => {
    let url;
    let msg;
    if (this.userData.id) {
      url = Urls.editSubSection;
      msg = 'Sub section Updated';
    } else {
      url = Urls.addSubSection;
      msg = 'Sub section Added';
    }
    this.apiService.postData(url, this.userData).subscribe((response: any) => {
      if (response.status === 0) {
        this.toastr.success(msg);
        formVal.resetForm();
        this.getSubSections();
      } else {
        this.toastr.error(Something_went_wrong);
      }
    });
  };
}
